import { utils } from '@/helpers';
import { Image } from '@alpine-iq/ui-library';
import React from 'react';
import styled, { css } from 'styled-components';

export type AvatarProps = {
	uid: string;
	storeID?: string;

	size?: number;
	style?: React.CSSProperties;
};

export default function Avatar({ uid, storeID, size }: AvatarProps) {
	return (
		<StyledLogoWrapper $size={size ?? 56}>
			<Image
				height={size ?? 56}
				width={size ?? 56}
				src={utils.getAvatar(uid, storeID)}
				alt={uid}
				css={css`
					// padding: 4px;
					border-radius: 50%;
				`}
			/>
		</StyledLogoWrapper>
	);
}

const StyledLogoWrapper = styled.div<
	{
		$size?: number;
	} & React.HTMLAttributes<HTMLDivElement>
>`
	user-select: none;
	border-radius: 50%;
	// background: var(--gray200, #fafbfc);
	height: ${(props) => props.$size || 56}px;
	width: ${(props) => props.$size || 56}px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.875rem;
	overflow: hidden;
`;
